import Card from 'react-bootstrap/Card';
export const SurveySuccess = () => {

    return (
        <Card style={{margin:'10% 25%'}}>
            <Card.Body>
                <Card.Title>
                    Thank you!
                </Card.Title>
                <Card.Body>
                    You have successfully submitted your survey.
                </Card.Body>
            </Card.Body>
            
        </Card>
    )
}